<div class="massive-services-container">
  <div class="header">
    <button class="btn-back" (click)="goBack()">← Volver</button>
    <h1>Carga de valores antecedentes backtesting</h1>
  </div>

  <div class="content">
    <div class="description-box">
      <p>Con esta herramienta puedes cargar valores antecedentes para backtesting cargando un fichero Excel con los datos necesarios.</p>
    </div>

    <!-- Excel File Selection -->
    <div class="form-section">
      <label class="form-label">Fichero Excel <span class="required">*</span></label>
      <div class="input-group">
        <input
          type="text"
          class="form-input"
          [value]="excelFilePath()"
          readonly
          placeholder="Selecciona un fichero Excel (.xlsx, .xls)..."
        />
        <button class="btn-browse" (click)="selectExcelFile()">Examinar</button>
        <button class="btn-download" (click)="downloadExampleExcel()" title="Descargar Excel de ejemplo">
          ⬇ Ejemplo
        </button>
      </div>
    </div>

    <!-- Error Message -->
    @if (errorMessage()) {
      <div class="error-box">
        <strong>Error:</strong> {{ errorMessage() }}
      </div>
    }

    <!-- Success Message -->
    @if (successMessage()) {
      <div class="success-box">
        <strong>Éxito:</strong> {{ successMessage() }}
      </div>
    }

    <!-- Submit Button -->
    <div class="button-container">
      <button
        class="btn-submit"
        [disabled]="!canSend()"
        (click)="sendRequest()">
        @if (isSending()) {
          Enviando...
        } @else {
          Enviar
        }
      </button>
    </div>
  </div>
</div>
